import propType from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title,
  seoTitle,
  keywords,
  seoKeywords,
  featuredImage,
  domain,
  uri,
  firstName,
  lastName,
  excerpt,
  siteAuthor
}) => {
  const image =
    featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData?.images
      ?.fallback?.src;
  const imageSrc = image && `${domain}${image}`;
  const siteUrl = `${domain}${uri}`;
  const author =
    (firstName && lastName && `${firstName} ${lastName}`) || siteAuthor;
  const description = excerpt.replace(/<[^>]*>?/gm, '');
  return (
    <Helmet
      title={seoTitle || title}
      meta={[
        {
          name: 'description',
          content: description
        },
        {
          name: 'keywords',
          content: seoKeywords || keywords?.join(',')
        },
        {
          property: 'og:title',
          content: title
        },
        {
          property: 'og:description',
          content: description
        },
        {
          property: 'og:type',
          content: 'article'
        },
        {
          property: 'og:url',
          content: siteUrl
        },
        {
          property: 'og:image',
          content: imageSrc
        },
        {
          name: 'twitter:creator',
          content: author
        },
        {
          name: 'twitter:title',
          content: title
        },
        {
          name: 'twitter:description',
          content: description
        },
        {
          name: 'twitter:image',
          content: imageSrc
        },
        {
          name: 'color-scheme',
          content: 'only light'
        }
      ]}
    />
  );
};

export default SEO;

SEO.propTypes = {
  title: propType.string.isRequired,
  seoTitle: propType.string.isRequired,
  keywords: propType.string.isRequired,
  seoKeywords: propType.string.isRequired,
  featuredImage: propType.string.isRequired,
  domain: propType.string.isRequired,
  uri: propType.string.isRequired,
  firstName: propType.string.isRequired,
  lastName: propType.string.isRequired,
  excerpt: propType.string.isRequired,
  siteAuthor: propType.string.isRequired
};
